import script from "./GroupPermissionsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./GroupPermissionsTable.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__